@if (workItem$ | async; as workItem) {
  <elder-basic-pane-layout class="full">
    <elder-pane class="flex-30">
      <elder-pane-header>
        <elder-pane-actions>
          <app-print-button
            appPrintCommand
            color="primary"
            [reportSpec]="labelReport$ | async"
            [printOptions]="labelPrintOptions$ | async"
            [disabled]="!(printingEnabled$ | async)"
          >
          </app-print-button>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
        </elder-pane-actions>
      </elder-pane-header>
      <elder-pane-content class="layout-col gap-sm place-between-stretch">
        <div class="layout-col gap-sm">
          <mat-form-field elderFormFieldLabel>
            <mat-label>{{ 'context.description' | translate }}</mat-label>
            <input
              matInput
              type="text"
              name="description"
              [value]="workItem.description"
              placeholder="{{ 'context.description' | translate }}"
              readonly
            />
          </mat-form-field>
          <mat-form-field elderFormFieldLabel>
            <mat-label>{{ 'context.note' | translate }}</mat-label>
            <textarea
              matInput
              name="note"
              [value]="workItem.note"
              placeholder="{{ 'context.note' | translate }}"
              readonly
            >
            </textarea>
          </mat-form-field>
          <mat-form-field elderFormFieldLabel>
            <mat-label>{{ 'context.items' | translate }}</mat-label>
            <input
              matInput
              type="text"
              name="item-count"
              [value]="workItem.orderedProduct?.quantity"
              placeholder="{{ 'context.items' | translate }}"
              readonly
            />
          </mat-form-field>
          <mat-form-field elderFormFieldLabel>
            <mat-label>{{ 'context.weight' | translate }}</mat-label>
            <input
              matInput
              type="text"
              name="totalWeight"
              [value]="workItem.totalWeight | elderQuantity"
              placeholder="{{ 'context.weight' | translate }}"
              readonly
            />
          </mat-form-field>
          @if (currentSegment$ | async; as currentSegment) {
            <mat-form-field elderFormFieldLabel>
              <mat-label>{{ 'numberSequences.numberSequence' | translate }}</mat-label>
              <input
                matInput
                type="text"
                name="numberSequence"
                value="{{ currentSegment?.sequenceNumber }}"
                placeholder="{{ 'numberSequences.numberSequence' | translate }}"
                readonly
              />
            </mat-form-field>
          }
          <elder-pane-subtitle>{{ 'context.characteristics' | translate }}</elder-pane-subtitle>
          <app-property-display [workItem]="workItem"> </app-property-display>
        </div>
      </elder-pane-content>
    </elder-pane>
    <app-terminal-work-item-instructions
      class="flex"
      [item]="workItem"
      [workCenterId]="workCenterId"
      [controlTerminal]="controlTerminal"
    >
    </app-terminal-work-item-instructions>
  </elder-basic-pane-layout>
}

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="onPreviewItemLabel(workItem)">
    <mat-icon>preview</mat-icon>
    <span>{{ 'labels.item' | translate }}</span>
  </button>

  <button mat-menu-item (click)="onPreviewPieceLabel(workItem)">
    <mat-icon>preview</mat-icon>
    <span>{{ 'labels.piece' | translate }}</span>
  </button>
</mat-menu>
